import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Directive } from '@angular/core';
import { FormsModule, ReactiveFormsModule, NG_VALIDATORS } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { routes } from './app.routes';
import { AppComponent } from './app.component';
import { IndexComponent } from './pages/index/index.component';
import { HeaderComponent } from './pages/header/header.component';
import { FooterComponent } from './pages/footer/footer.component';
import { LoginComponent } from './pages/login/login.component';
import { ControlMessagesComponent } from './control-messages.component';
import { ValidationService } from './validation.service';
import { AuthGuard } from './_guards/index';
import { CanDeactivateGuard } from './_guards/index';
import { StudentInfoService } from './_services/student-info.service';
import { AuthenticationService, UserService, PersonalInfoService, CountryService, StateService } from './_services/index';
import { APP_CONFIG, AppConfig } from './app.config';
import { CommonModule } from '@angular/common';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { SignupComponent } from './pages/signup/signup.component';
import { ResetComponent } from './pages/reset/reset.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PersonalInformationComponent } from './pages/profile/personal-information/personal-information.component';
import { AcademicInformationComponent } from './pages/profile/academic-information/academic-information.component';
import { BackgroundInformationComponent } from './pages/profile/background-information/background-information.component';
import { PriorHigherEducationComponent } from './pages/profile/prior-higher-education/prior-higher-education.component';
import { FutureCollegePlansComponent } from './pages/profile/future-college-plans/future-college-plans.component';
import { AcademicCareerGoalsComponent } from './pages/profile/academic-career-goals/academic-career-goals.component';
import { ExtracurricullarActivitiesComponent } from './pages/profile/extracurricullar-activities/extracurricullar-activities.component';
import { EmploymentComponent } from './pages/profile/employment/employment.component';
import { TextMaskModule } from 'angular2-text-mask';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { LeftsidebarComponent } from './pages/leftsidebar/leftsidebar.component';
import { SocialLoginModule, AuthServiceConfig } from 'angular4-social-login';
//import { GoogleLoginProvider, FacebookLoginProvider } from 'angular4-social-login';
import { UserDashboardComponent } from './pages/user-dashboard/user-dashboard.component';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { StudentChecklistComponent } from './pages/student-checklist/student-checklist.component';
import { StudentDefaultChecklistComponent } from './pages/student-default-checklist/student-default-checklist.component';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieModule } from 'ngx-cookie';
import { DynamicFormsBasicUIModule } from '@ng2-dynamic-forms/ui-basic';
import { customValidator, customDateRangeValidator } from './pages/profile/app.validators';
import { DynamicFormsCoreModule } from '@ng2-dynamic-forms/core';
import { PartnerQuestionsComponent } from './pages/profile/partner-questions/partner-questions.component';
import { SarUploadComponent } from './pages/sar-upload/sar-upload.component';
import { DialogComponent } from './pages/dialog/dialog.component';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DialogPdfComponent } from './pages/profile/dialog-pdf/dialog.component';
import { StudentCalculatorComponent } from './pages/student-calculator/student-calculator.component';
import { CalculatorDialogComponent } from './pages/calculator-dialog/calculator-dialog.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { ConfirmationDialogComponent } from './pages/profile/confirmation-dialog/confirmation-dialog.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DigitalsignatureDialogComponent } from './pages/profile/digitalsignature-dialog/digitalsignature-dialog.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GoogleAnalyticsEventsService } from './_services/google-analytics-events.service';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './pages/terms-condition/terms-condition.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ScholarshipAcceptanceComponent } from './pages/scholarship-acceptance/scholarship-acceptance.component';
import { StudentResourceComponent } from './pages/student-resource/student-resource.component';
import { StudentOpportunitiesComponent } from './pages/student-opportunities/student-opportunities.component';
import { StudentNewDashboardComponent} from './pages/student-new-dashboard/student-new-dashboard.component';
import { RequestDocumentComponent} from './pages/request-document/request-document.component';
import { CarouselModule } from 'angular4-carousel';
import {Autosize} from 'ng-autosize';
import { SafeHtmlPipe } from './pages/index/index.component';

import { SubsectionComponent,TextQuestiontypeComponent,BooleanQuestiontypeComponent,AddressQuestiontypeComponent,SectionPaneComponent,SidebarComponent,CommunicationPreferenceComponent,RacialBackgroundComponent,EthnicBackgroundComponent,CareerAcademyComponent,PhoneComponent,SinglePhoneComponent,CheckmarkWithItemsComponent,CompoundCheckmarkComponent,OrgRoleYearsComponent,AcademicProgramsComponent,PDFUploadComponent,PDFRequestComponent,DropdownQuestiontypeComponent,CheckboxCollectionComponent,AcademicMajorComponent,ProfessionalGoalComponent,HighschoolComponent,CollegeComponent,TextareaQuestiontypeComponent } from './pages/questionnaire/questiontypes';
import { TooltipModule } from 'ng2-tooltip-directive';
const config = new AuthServiceConfig([
  /* {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(AppConfig.googleLoginProvider)
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider(AppConfig.facebookLoginProvider)
  } */
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    ControlMessagesComponent,
    WelcomeComponent,
    ForgotComponent,
    SignupComponent,
    ResetComponent,
    ProfileComponent,
    PersonalInformationComponent,
    AcademicInformationComponent,
    BackgroundInformationComponent,
    PriorHigherEducationComponent,
    FutureCollegePlansComponent,
    AcademicCareerGoalsComponent,
    ExtracurricullarActivitiesComponent,
    EmploymentComponent,
    LeftsidebarComponent,
    UserDashboardComponent,
    StudentChecklistComponent,
    StudentDefaultChecklistComponent,
    PartnerQuestionsComponent,
    SarUploadComponent,
    DialogComponent,
    DialogPdfComponent,
    StudentCalculatorComponent,
    CalculatorDialogComponent,
    ResourcesComponent,
    ConfirmationDialogComponent,
    DashboardComponent,
    DigitalsignatureDialogComponent,
    PrivacyPolicyComponent,
    TermsConditionComponent,
    ChangePasswordComponent,
    ScholarshipAcceptanceComponent,
    StudentResourceComponent,
    StudentOpportunitiesComponent,
    StudentNewDashboardComponent,
    SubsectionComponent,
    TextQuestiontypeComponent,
    BooleanQuestiontypeComponent,
    AddressQuestiontypeComponent,
    SectionPaneComponent,
    SidebarComponent,
    CommunicationPreferenceComponent,
    RacialBackgroundComponent,
    EthnicBackgroundComponent,
    CareerAcademyComponent,
    PhoneComponent,
    SinglePhoneComponent,
    CheckmarkWithItemsComponent,
    CompoundCheckmarkComponent,
    OrgRoleYearsComponent,
    AcademicProgramsComponent,
    PDFUploadComponent,
    PDFRequestComponent,
    DropdownQuestiontypeComponent,
    CheckboxCollectionComponent,
    AcademicMajorComponent,
    ProfessionalGoalComponent,
    HighschoolComponent,
    CollegeComponent,
    TextareaQuestiontypeComponent,
    Autosize,
    SafeHtmlPipe,
    RequestDocumentComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {useHash: true}),
    TextMaskModule,
    CollapseModule.forRoot(),
    SocialLoginModule,
    NgxPageScrollModule,
    MaterialModule,
    BrowserAnimationsModule,
    CookieModule.forRoot(),
    DynamicFormsCoreModule.forRoot(),
    DynamicFormsBasicUIModule,
    NguiAutoCompleteModule,
    PdfViewerModule,
    NgxChartsModule,
    CarouselModule,
    TooltipModule
  ],
  providers: [
    ValidationService,
    AuthGuard,
    CanDeactivateGuard,
    AuthenticationService,
    UserService,
    PersonalInfoService,
    CountryService,
    StudentInfoService,
    StateService,
    GoogleAnalyticsEventsService,
    { provide: APP_CONFIG, useValue: AppConfig, },
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    },
    {
      provide: NG_VALIDATORS,
      useValue: customValidator,
      multi: true
  },
  {
      provide: NG_VALIDATORS,
      useValue: customDateRangeValidator,
      multi: true
  }
  ],
  entryComponents: [
    DialogComponent,
    DialogPdfComponent,
    CalculatorDialogComponent,
    ConfirmationDialogComponent,
    DigitalsignatureDialogComponent,
    SubsectionComponent,
    TextQuestiontypeComponent,
    BooleanQuestiontypeComponent,
    AddressQuestiontypeComponent,
    SectionPaneComponent,
    SidebarComponent,
    CommunicationPreferenceComponent,
    RacialBackgroundComponent,
    EthnicBackgroundComponent,
    CareerAcademyComponent,
    PhoneComponent,
    SinglePhoneComponent,
    CheckmarkWithItemsComponent,
    CompoundCheckmarkComponent,
    AcademicProgramsComponent,
    PDFUploadComponent,
    PDFRequestComponent,
    DropdownQuestiontypeComponent,
    CheckboxCollectionComponent,
    AcademicMajorComponent,
    ProfessionalGoalComponent,
    HighschoolComponent,
    CollegeComponent,
    TextareaQuestiontypeComponent,
    RequestDocumentComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/app.module.ts